import { kebabCase } from "lodash-es";

export function slugify(value: string): string {
  return kebabCase(value);
}
